import request from '@/http/http'
const PREFIX = 'api/deer/account';
// 验证账户可否登录
export function preLoginCheck(data) {
    return request({
        url: PREFIX+'/pre-login-check',
        method: 'post',
        data
    })
}
//预登录
export function getTenantsLogin(query) {
    return request({
        url: PREFIX+'/get-tenants',
        params:query
    })
}